import Player from '@vimeo/player';

'use strict';

/**
 * @ngdoc function
 * @name exhibitorPortalApp.controller:VideosCtl
 * @description
 * # Videos Ctrl
 * Controller of the exhibitorPortalApp
 */
(function (angular, window) {
  angular.module('exhibitorPortalApp')
    .controller('VideosCtrl', VideosController);

VideosController.$inject = ['$scope', 'ShowService', 'OrderService'];

function VideosController($scope, ShowService, OrderService) {

  var self = this;

  self.hasDigitalBackpack = function () {
    if (
      !ShowService.data.currentShow ||
      !ShowService.data.currentShow.ShowCode ||
      !OrderService.data.orders ||
      !OrderService.data.orders[ShowService.data.currentShow.ShowCode]
    ) {
      return false;
    }
    const orders = OrderService.data.orders[ShowService.data.currentShow.ShowCode];
    const digitalBackpackCodes = ['802'];
    for (var i = 0; i < orders.length; i++) { 
      for (var a = 0; a < orders[i].Transactions.length; a++) {
        if (
          digitalBackpackCodes.indexOf(orders[i].Transactions[a].ProductCode) > -1 &&
          orders[i].Transactions[a].TransTypeCode === 'PUR' &&
          orders[i].Transactions[a].TransStatus !== 'VOIDED'
        ) {
          return true;
        }
      }
    }
    return false;
  } 
  

  var player = null;

  self.videoConfig = getVideoConfiguration();
  self.videoConfigDigitalBackpack = getVideoConfigurationDigitalBackpack();
  self.activeVideo = null;
  self.isModalOpen = false;

  function getVideoConfiguration() {
    return [
      { title: 'Your Guide to the Maritz Lead Retrieval App', id: '1048205462', thumbnailImage: 'your-guide.png' },
      { title: 'Maritz Lead Generation', id: '1045759054', thumbnailImage: 'lead-generation.png' },
      { title: 'Optimizing Maritz Lead Retrieval', id: '1045762374', thumbnailImage: 'optimizing-lead-retrieval.png' },
      { title: 'Maritz Exhibitor Etiquette', id: '1045738840', thumbnailImage: 'exhibitor-etiquette.png' },
      { title: 'Maritz Return on Investment', id: '1045764696', thumbnailImage: 'return-on-investment.png' },
    ];
  }
  function getVideoConfigurationDigitalBackpack() {
    if (self.hasDigitalBackpack()){
      let videoList = [
        { title: 'Your Digital Backpack Exhibitor User Guide', id: '1041254938', thumbnailImage: 'dbp-guide.png' },
      ];
      return videoList;
    }
    else{
      return null;
    }
  }

  self.playVideo = function (videoConfig) {
    self.activeVideo = videoConfig;
    self.isModalOpen = true;

    document.body.classList.add('video-modal-open');
  };

  self.closeModal = function () {
    if (player) {
      try {
        player.unload();
      } catch (e) {}
      player = null;
    }

    self.isModalOpen = false;
    document.body.classList.remove('video-modal-open');
  };

  $scope.$watch(
    function () { return self.isModalOpen; },
    function (isOpen) {

      if (isOpen && self.activeVideo) {

        setTimeout(function () {

          var el = document.getElementById('modal_vimeo_player');

          player = new Player(el, {
            id: self.activeVideo.id,
            autoplay: true,
            autopause: true
          });

          player.getVideoWidth().then(function (width) {
            player.getVideoHeight().then(function (height) {

              var wrapper = document.querySelector('.video-modal .video-wrapper');

              if (!wrapper) return;

              
              var ratio = width / height;

              if (ratio < 1) {
                wrapper.style.maxWidth = "min(420px, 90vw)";
                wrapper.style.aspectRatio = "9 / 16";

                wrapper.style.maxHeight = "80vh";

              } else {
                wrapper.style.maxWidth = "min(1100px, 95vw)";
                wrapper.style.aspectRatio = "16 / 9";

                wrapper.style.maxHeight = "none";
              }
            });
          });

          registerPlayerEventListeners(player, self.activeVideo);

        }, 0);
      }
    }
  );

  function registerPlayerEventListeners(player, videoConfig) {
    onPlayerLoaded(player, videoConfig);
    onPlayerPlay(player);
    onPlayerEnded(player);
    onPlayerTimeUpdate(player);
  }

  function onPlayerLoaded(player, videoConfig) {
    player.on('loaded', function (eventData) {
      safeApply(function () {
        videoConfig.loaded = true;
      });
      pushEvent(player, "video_load", eventData);
    });
  }

  function onPlayerPlay(player) {
    player.on('play', function (eventData) {
      pushEvent(player, "video_play", eventData);
    });
  }

  function onPlayerEnded(player) {
    player.on('ended', function (eventData) {
      pushEvent(player, "video_ended", eventData);
    });
  }

  function onPlayerTimeUpdate(player) {
    var thresholds = [25, 50, 75, 100];
    var triggered = [];

    player.on('timeupdate', function (eventData) {
      thresholds.forEach(function (t) {
        var progress = Math.floor(eventData.percent * 100);

        if (progress >= t && triggered.indexOf(t) === -1) {
          triggered.push(t);
          eventData.percent = t / 100;
          pushEvent(player, "video_timeupdate", eventData);
        }
      });
    });
  }

  function safeApply(fn) {
    if (!$scope.$$phase) {
      $scope.$apply(fn);
    } else {
      fn();
    }
  }

  function pushEvent(player, eventName, eventData) {
    if (typeof dataLayer === 'undefined') return;

    Promise.all([
      player.getVideoUrl(),
      player.getVideoTitle(),
      eventData.id ? Promise.resolve(eventData.id) : player.getVideoId()
    ]).then(function (result) {

      var data = {
        event: eventName,
        video_provider: "Vimeo",
        video_url: result[0],
        video_title: result[1],
        video_id: result[2]
      };

      if (eventData.seconds !== undefined) {
        data.video_current_time = eventData.seconds;
      }

      if (eventData.duration !== undefined) {
        data.video_duration = eventData.duration;
      }

      if (eventData.percent !== undefined) {
        data.video_percent = Math.floor(eventData.percent * 100);
      }

      dataLayer.push(data);
    });
  }
}

})(angular, window);